// extracted by mini-css-extract-plugin
export default {"lightPanel":"lightPanel_lightPanel__qSb7S"};